// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"ProgramsDropdown_ItemsWrapper__BYTu2","Slide":"ProgramsDropdown_Slide__gSk2X","Active":"ProgramsDropdown_Active__51ISx"};